module.exports = __webpack_public_path__ + "static/media/barcode.0e74ffbf.png";